import React, { useState } from 'react';
import { DEFAULT_LANGUAGE, Language } from './types';
import { LanguageContext } from './utils';

interface LanguageContextWrapperProps {
  children?: React.ReactNode
};

const LanguageContextWrapper = ({ children }: LanguageContextWrapperProps) => {
  const [ language, setLanguage ] = useState<Language>(DEFAULT_LANGUAGE);

  return (
    <LanguageContext.Provider value={{ language, setLanguage }}>
      { children }
    </LanguageContext.Provider>
  );
};

export default LanguageContextWrapper;